import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme, Icon, withTheme } from '../..'

// Component to surface in storybook
import IconButton from '.'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/IconButton', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

const _clickHandler = e => {
  window.alert('icon clicked')
}

const ThemingExample = withTheme(({ clickHandler }) => {
  return (
    <IconButton onClick={clickHandler}>
      <Icon type='clipboard' duotone={true} />
    </IconButton>
  )
})

// Stories
stories
  .add('Basic', () => (
    <ThemeProvider theme={builtTheme}>
      <IconButton onClick={_clickHandler}>
        <Icon type='clipboard' />
      </IconButton>
    </ThemeProvider>
  ))
  .add('Custom Color', () => (
    <ThemeProvider theme={builtTheme}>
      <IconButton onClick={_clickHandler}>
        <Icon type='clipboard' baseColor='purple' accentColor='orange' />
      </IconButton>
    </ThemeProvider>
  ))
  .add('Themed', () => (
    <ThemeProvider theme={builtTheme}>
      <ThemingExample clickHandler={_clickHandler} />
    </ThemeProvider>
  ))
